export const YES_NO_CODES = new Set(["RALL", "BEND", "SHOT", "MAGNA", "STLEG"]);

export const GAUGE_CODES: ReadonlySet<string> = new Set([
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
]);
